<template>
    <Popper v-bind="$attrs" :hover="hover" :arrow="arrow">
        <slot></slot>

        <template #content>
            <div class="text-white rounded-lg p-4">
                <template v-if="$slots['content']">
                    <slot name="content"></slot>
                </template>

                <template v-else>{{ content }}</template>
            </div>
        </template>
    </Popper>
</template>

<script>
import Popper from "vue3-popper";

export default {
    components: {
        Popper
    },
    props: {
        content: String,
        hover: {
            type: Boolean,
            default: true
        },
        arrow: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss">

:root {
    --popper-theme-background-color: theme('colors.dark');
    --popper-theme-background-color-hover: theme('colors.dark');
    --popper-theme-border-radius: theme('borderRadius.lg');
}

</style>
